import * as S from './Divider.styled'
import { useRecoilValue } from 'recoil'
import { showProductBleedAtom } from 'atoms'

export const Divider = ({
  whiteBorder,
  left,
  padding,
  productBleedBackground,
  ...props
}) => {
  const showProductBleed = useRecoilValue(showProductBleedAtom)

  return (
    <S.Divider
      position="absolute"
      left={`${whiteBorder ? `${left - whiteBorder}` : `${left + padding}`}px`}
      height={`calc(100% - ${padding * 2}px)`}
      top={`${padding}px`}
      width={whiteBorder ? `${padding}px` : '0px'}
      background={
        whiteBorder && showProductBleed ? productBleedBackground : undefined
      }
      borderLeft={
        !whiteBorder && showProductBleed
          ? `${padding}px solid ${productBleedBackground}`
          : undefined
      }
      whiteBorder={whiteBorder}
      {...props}
    />
  )
}

export default Divider
